import { render, staticRenderFns } from "./ExportVariantsModal.vue?vue&type=template&id=cb5981c4&"
import script from "./ExportVariantsModal.vue?vue&type=script&lang=js&"
export * from "./ExportVariantsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports